import api from "./axios";

export const getOrders = (params = {}) => api.get("/orders", { params });
export const getOrder = (publicId) => api.get(`/orders/${publicId}`);
export const createOrder = (data) => api.post("/orders", data);
export const confirmOrder = (publicId, data) => api.post(`/orders/${publicId}/confirm`, data);
export const markOrderPreparing = (publicId, data) => api.post(`/orders/${publicId}/preparing`, data);
export const markOrderReady = (publicId, data) => api.post(`/orders/${publicId}/ready`, data);
export const completeOrder = (publicId, data) => api.post(`/orders/${publicId}/complete`, data);
export const cancelOrder = (publicId, data) => api.post(`/orders/${publicId}/cancel`, data);
export const rejectOrder = (publicId, data) => api.post(`/orders/${publicId}/reject`, data);
